// Read-only mode banner component
// CREATED: Displays a subtle banner to inform users they are in consultation mode
// Used by: UserManagement, SiteManagement, ServiceManagement, TemplateLibrary (mobile view)

import { Eye } from 'lucide-react';

interface ReadOnlyBannerProps {
  message?: string;
  className?: string;
}

export function ReadOnlyBanner({
  message = 'Mode consultation - Passez sur ordinateur pour modifier',
  className = ''
}: ReadOnlyBannerProps) {
  return (
    <div className={`bg-gray-100 border-b border-gray-200 py-2 ${className}`}>
      <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
        <Eye size={16} />
        <span>{message}</span>
      </div>
    </div>
  );
}
